/**
 * Calculate the factorial (i.e. n!) of number n
 * @param n a none negative integer
 * @returns the factorial of n, n!
 */
export const factorial = (n) => {
    if (Math.abs(n - Math.trunc(n)) > 0 || n < 0) {
        throw new Error(`Can only take the factorial of a positive integer number. Given number is ${n}`);
    }
    let f = 1;
    if (n >= 2) {
        for (let i = 2; i <= n; i++) {
            f *= i;
        }
    }
    return f;
};
